import { Skeleton, Typography, useTheme } from '@mui/material';

import { ApplicationStatusChip } from 'sharedComponents/Chip/StatusChip';
import {
  AutomationAnswer,
  AutomationContainer,
  AutomationDetail,
  AutomationStatusChipContainer,
  BoldText,
  ListItemContainer,
} from 'features/Automations/styles';
import { ATSAutomationListTestIds } from 'data-testids/ATS';
import { AutomationInfoProps, AutomationListItemProps } from 'features/Automations/types';
import { useQueryGetApplicationStatusListData } from 'features/Automations/api/createQueries';
import auth from 'utils/auth';
import { AutomationListVariant } from 'features/Automations/enums';

export const AutomationListItemSkeleton = () => {
  const theme = useTheme();

  return (
    <>
      <AutomationContainer data-testid={ATSAutomationListTestIds.LIST_SKELETON}>
        <Skeleton sx={{ fontSize: theme.typography.body2.fontSize }} />
        <Skeleton sx={{ fontSize: theme.typography.body2.fontSize }} />
      </AutomationContainer>
    </>
  );
};

export const AutomationInfo: React.FC<AutomationInfoProps> = ({ answer, status, variant }) => {
  const isEditable = variant === AutomationListVariant.EDITABLE;
  const isReadOnly = variant === AutomationListVariant.READ_ONLY;
  return (
    <AutomationDetail>
      &gt;
      <Typography sx={{ px: 0.5 }}>If a candidate responds </Typography>
      <AutomationAnswer data-testid={ATSAutomationListTestIds.CANDIDATE_ANSWER}>
        {answer}
      </AutomationAnswer>
      <Typography sx={{ px: 0.5 }}>then update their status to</Typography>
      {isEditable && status && (
        <AutomationStatusChipContainer>
          <ApplicationStatusChip
            label={status.label}
            color={status.color}
            dataTestId={ATSAutomationListTestIds.NEW_STATUS_CHIP}
          />
        </AutomationStatusChipContainer>
      )}
      {isReadOnly && <AutomationAnswer>{status.label}</AutomationAnswer>}
    </AutomationDetail>
  );
};

export const AutomationListItem: React.FC<AutomationListItemProps> = ({ automation, variant }) => {
  const theme = useTheme();
  const districtId: number | undefined = auth.getUser()?.profile?.district.id;
  const { data: applicationStatuses, isLoading } = useQueryGetApplicationStatusListData(districtId);
  const selectedApplicationStatus = applicationStatuses?.find(
    (status) => status.id === automation.action.new_status_id
  );

  return (
    <ListItemContainer listVariant={variant}>
      <BoldText>Automation {automation.order + 1}:</BoldText>
      {isLoading && !applicationStatuses ? (
        <Skeleton sx={{ fontSize: theme.typography.body2.fontSize }} />
      ) : (
        <AutomationInfo
          answer={automation.trigger.answer}
          status={selectedApplicationStatus}
          variant={variant}
        />
      )}
    </ListItemContainer>
  );
};
